module.exports = __webpack_public_path__ + "static/monster-peek-ca39ef8b8768282e4122b3407d0b954e.png";